import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=22ff839a&scoped=true"
import script from "./icons.vue?vue&type=script&lang=js"
export * from "./icons.vue?vue&type=script&lang=js"
import style0 from "./icons.vue?vue&type=style&index=0&id=22ff839a&prod&scoped=true&lang=css"
import style1 from "./icons.vue?vue&type=style&index=1&id=22ff839a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff839a",
  null
  
)

export default component.exports